<div
  class="admin-selection-action"
  (click)="executeAction()"
  (keydown)="null"
>
  {{ label | translate}}

  <mat-icon>
    keyboard_arrow_right
  </mat-icon>
</div>
